import styled from "styled-components";

export const WidthContainer = styled.div`
    display: flex;
    align-self: center;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

export const ImageLayer = styled.div`
    width: ${p => p.layout.width}px;
    height: ${p => p.layout.height}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    position: absolute;
    background-image: url(${p => p.src});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;
// Customize text top alignment
export const TopPositionContainer = styled.div`
    display: flex;
    justify-content: ${P => P.textAlign || "center"};
    align-items: ${p => {
        switch (p.verticalAlign) {
            case "top": return "flex-start";
            case "bottom": return "flex-end";
            case "center":
            default:
                return "center";
        }
    }};
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;
// Customize text for quote text
export const QuoteTextContainer = styled.div`
    position: absolute;
    top: 13%;
    bottom: 130px;
    left: 50%;
    transform: translateX(-50%);
    width: 250px;
    display: flex;
    flex-direction: column;
    justify-content: ${p => {
        switch (p.verticalAlign) {
            case "top": return "flex-start";
            case "bottom": return "flex-end";
            case "center":
            default:
                return "center";
        }
    }};
    align-items: ${p => {
        switch (p.textAlign) {
            case "left": return "flex-start";
            case "right": return "flex-end";
            case "center":
            default:
                return "center";
        }
    }};
   border: 1.5px dashed #FFFFFF;
    text-align: ${p => p.textAlign || "center"};
    color: ${p => p.textColor || "#fff"};
    font-size: ${p => p.fontSize || 17}px;
    font-family: ${p => p.textFont || "Manrope"};
    font-weight: 600;
    overflow: hidden;
    word-wrap: break-word;
    white-space: pre-wrap;
`;


export const FooterSection = styled.div`
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
`;

export const InfoCard = styled.div`
    height: 40px;
    width: 100%;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 20px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    border: 1px solid #00000029;
    box-shadow: 0 3px 6px #00000029;
    margin-bottom: 10px;
`;

export const IconCard = styled.div`
    height: 40px;
    width: 180px;
    border-radius: 20px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
`;

export const ProfileImage = styled.img`
    width: 30px;
    background: #80808080;
    height: 30px;
    border-radius: 100%;
    object-fit: cover;
    margin-right: 10px;
    box-shadow: 0 3px 6px #00000029;
`;

export const IconImage = styled.img`
    width: 30px;
    background: white;
    border-radius: 100px;
    box-shadow: 0 3px 6px #00000029;
    height: 30px;
`;


export const ArticleLayer = styled.div`
    position: absolute;
    z-index: 2;
    left: ${p => p.layout.left + 10}px;
    top: ${p => p.layout.top + 24}px;
    width: ${p => p.layout.width - 20}px;
    height: ${p => p.layout.height - 30}px;
    background: #fff;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 15px;
    overflow-y: ${p => p.overflowY || "auto"};
`;

export const ArticleHeader = styled.div`
    font-size: 22px;
    font-weight: bold;
    color: #000000;
    padding: 10px 0px;
    font-family: 'Manrope', sans-serif;
    line-height: 1.2;
    letter-spacing: 0px;
`;

export const ArticleContent = styled.div`
    padding: 5px 0px;
    font-family: 'Manrope', sans-serif;
    font-size: 16px;
    font-weight: normal;
    color: #000000;
    background: #fff;
    letter-spacing: 0px;
    flex: 1;
`;

export const ArticleImageRow = styled.div`
    display: flex;
    gap: 10px;
    background: #fff;
    height: auto;
    flex-wrap: wrap;
`;

export const ArticleImageColumn = styled.div`
    flex: ${p => p.flex || 1};
    position: relative;
    display: flex;
    flex-direction: column;
    height: 150px;
    width: 100px;
    background: ${({ bgImage, bgColor }) => 
        bgImage
            ? `url(${bgImage}) center center / cover no-repeat`
            : bgColor || "#fff"};
    background-size: cover;
    background-repeat: no-repeat
    border: 1px solid #80808080;
    align-items: center;
    color: #000;
    justify-content: center;

`;
export const ZeroSizeSvg = styled.svg`
    width: 0px;
    height: 0px;
    position: absolute;
`;

export const PlainImageLayer = styled.div`
    width: ${p => p.layout.width}px;
    height: ${p => p.layout.height}px;
    position: absolute;
    left: ${p => p.layout.left}px;
    top: ${p => p.layout.top}px;
    background-image: url(${ p => p.src });
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: ${p => p.layout.borderRadius}px;
`;

export const PlainImageTextLayer = styled.div`
    width: ${p => p.layout.width}px;
    height: ${p => p.layout.height}px;
    position: absolute;
    left: ${p => p.layout.left}px;
    top: ${p => p.layout.top}px;
    background-image: url(${ p => p.src });
    background-size: contain;
    background-position: ${p => p.position || "center"};
    background-repeat: no-repeat;
    &:after {
        position: absolute; 
        top: 0; 
        left: 0; 
        bottom: 0; 
        right: 0;
        margin-top: 40px; 
        z-index: 99999; 
        font-size: 16px; 
        color: #FFFFFF;
        text-align: center;
        text-shadow: 0px 0px 5px black;
        padding: 5px;
    }
`;

export const BackgroundLayer = styled(PlainImageLayer)`
    filter: url(#filter-background);
`;

export const PrimaryLayer = styled(PlainImageLayer)`
    filter: url(#filter-primary);
`;

export const SecondaryLayer = styled(PlainImageLayer)`
    filter: url(#filter-secondary);
`;

//Implement covering the PlainImageLayer for main display
export const MainQuotesDisplay = styled.div`
    position: ${p => p.position || "relative"};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 305px;
    width: 165px;
    overflow: hidden;
    border-radius: 30px;
    background-color: ${p => (!p.src ? "#808080" : "transparent")}; 
    background-image: ${p => (p.src ? `url(${p.src})` : "none")};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

`;

export const MainQuoteCard = styled.div`
    position: absolute;
    bottom: 0;
    height: 25px;
    width: 100px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    box-shadow: 0 3px 6px #00000029;
    margin-bottom: 10px;
    
`;

export const MainQuoteText = styled.div`
    display: flex;
    flex-direction: column;
    width: 90%;
    height: ${({ height }) => height || "80%"};
    text-align: ${({ textAlign }) => textAlign || "center"};
    color: ${({ textColor }) => textColor || "#000"};
    font-size: ${({ fontSize }) => `${fontSize || 15}px`};
    font-family: ${({ textFont }) => textFont || "Manrope"};
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    word-wrap: break-word;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    line-height: 1.2;
    max-height: 100%;
    margin-top: -20px;

    justify-content: ${({ verticalAlign }) => {
        switch (verticalAlign) {
            case "top": return "flex-start";
            case "bottom": return "flex-end";
            default: return "center";
        }
    }};
    align-items: ${({ textAlign }) => {
        switch (textAlign) {
            case "left": return "flex-start";
            case "right": return "flex-end";
            default: return "center";
        }
    }};
    text-align: ${({ textAlign }) => textAlign};
`;

export const ArticleHeaderBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const CrossButton = styled.div`
    align-self: flex-end;
    position: ${p => p.position || "absolute"};
    top: ${p => p.top || "0px"};
    right: ${p => p.right || "16px"};
    color: ${p => p.color || "#000"};
    font-size: ${p => p.fontSize || "30px"};  
    font-weight: 10;
    z-index: 1000;
`;
